export const missingImage = (orderImages: OrderImage[]): number =>
{
    let images = orderImages.filter(x =>  (!x.url || x.url.length === 0) && x.imageType !== "Custom");
    return images.length;
}